import { ROUTES } from '@/consts/routes';

const BASE_URL = import.meta.env.VITE_BASE_URL;
export const clerkConfig = {
  publishableKey: String(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY),
  signInUrl: `${BASE_URL}${ROUTES.auth.login}`,
  signUpUrl: `${BASE_URL}${ROUTES.auth.signup}`,
  signInFallbackRedirectUrl: BASE_URL,
  signUpFallbackRedirectUrl: BASE_URL
} as const;
